import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "p-fluid mb-3" }
const _hoisted_4 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_5 = { class: "font-bold mb-2" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = {
  key: 0,
  class: "block text-gray-400"
}
const _hoisted_8 = {
  key: 1,
  class: "block text-gray-200"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_11 = { class: "font-bold text-pink-600 mb-2" }
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_14 = { class: "font-bold mb-2" }
const _hoisted_15 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", null, _toDisplayString(_ctx.valueLabel) + " -> " + _toDisplayString(_ctx.uuidLabel), 1),
    (_ctx.help)
      ? (_openBlock(), _createElementBlock("small", {
          key: 0,
          class: "block text-gray-400 mb-3",
          innerHTML: _ctx.help
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FieldTextarea, {
        modelValue: _ctx.values,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values) = $event)),
        modelModifiers: { trim: true },
        name: "values",
        "errors-map": _ctx.errorsMap,
        label: _ctx.valueLabel,
        disabled: _ctx.loading
      }, null, 8, ["modelValue", "errors-map", "label", "disabled"])
    ]),
    _createVNode(_component_PrimeVueButton, {
      class: "p-button-secondary w-full mb-3",
      label: _ctx.$t('convert'),
      loading: _ctx.loading,
      disabled: !_ctx.values,
      onClick: _ctx.convert
    }, null, 8, ["label", "loading", "disabled", "onClick"]),
    (_ctx.groupedFound.length || _ctx.notFound.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedFound, (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-4",
              key: entry.value
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(entry.value), 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.endpoints, (group) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-3",
                    key: group.endpoint_id
                  }, [
                    _createVNode(_component_FieldTextarea, {
                      class: "mb-0",
                      "model-value": group.text,
                      rows: group.rows,
                      readonly: ""
                    }, null, 8, ["model-value", "rows"]),
                    (group.endpoint_compiled_name)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(group.endpoint_compiled_name), 1))
                      : _createCommentVNode("", true),
                    (group.endpoint_comment)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(group.endpoint_comment), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (entry.endpoints.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_FieldTextarea, {
                        "model-value": entry.allText,
                        help: _ctx.$t('all_uuids'),
                        rows: entry.allRows,
                        readonly: ""
                      }, null, 8, ["model-value", "help", "rows"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (_ctx.notFound.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('not_found')), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notFound, (value) => {
                    return (_openBlock(), _createElementBlock("div", { key: value }, _toDisplayString(value), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.allUuidsText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('all_uuids')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_FieldTextarea, {
                    "model-value": _ctx.allUuidsText,
                    rows: _ctx.allUuidsRows,
                    readonly: ""
                  }, null, 8, ["model-value", "rows"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}